import { InternalError } from '@/components/common';

const InternalErrorPage = () => {
  return <InternalError />;
};

export default InternalErrorPage;
